import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import ElementUI from "element-ui";
import viLang from "element-ui/lib/locale/lang/vi";
import "element-ui/lib/theme-chalk/index.css";
import "vuetify/dist/vuetify.min.css";
import MaterialKit from "./plugins/material-kit";
import mdiVue from "mdi-vue/v2";
import * as mdijs from "@mdi/js";
import "@/assets/local.css";
import store from "./store";
import InfiniteLoading from "vue-infinite-loading";
import VueSocialSharing from "vue-social-sharing";
import VueSocials from "vue-socials";
import i18n from "../src/plugins/i18n";
import FlagIcon from "vue-flag-icon";
import Datetime from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

Vue.use(Datetime);
Vue.use(FlagIcon);
Vue.config.productionTip = false;
Vue.use(VueSocials);
Vue.use(VueSocialSharing);
Vue.use(InfiniteLoading, {
  props: {
    spinner: "default"
    /* other props need to configure */
  },
  system: {
    throttleLimit: 50
    /* other settings need to configure */
  }
});

Vue.config.productionTip = false;

Vue.use(Vuetify);
Vue.use(MaterialKit);
Vue.use(ElementUI, { locale: viLang });
Vue.use(mdiVue, {
  icons: mdijs
});

const vuetify = new Vuetify();

const NavbarStore = {
  showNavbar: false
};

Vue.mixin({
  data() {
    return {
      NavbarStore
    };
  }
});

if (process.env.VUE_APP_BASE_VERSION !== "local") {
  // console.log = () => {};
  // console.warn = () => {};
  // console.error = () => {};
  // console.info = () => {};
}

new Vue({
  router,
  vuetify,
  icons: mdijs,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
